
import Container from '@/components/container';
import Content from '@/components/content';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';
import { Comparator } from '@/ui-kit/enums';
import { StyleFontWeightType, StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Button from '@/ui-kit/components/button';

export default {
  /**
   * @component BlogBoxComponent
   *
   * @public
   */

  name: 'BlogBoxComponent',
  components: {
    Container,
    Content,
    Button,
    LazyImage,
    Typography,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: () => {},
    },
    link: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleFontWeightType,
      StyleColorSchemeType,
      TypographyType,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.image.dimensions);
    },
    imageSizes() {
      return [
        {
          comparator: Comparator.Greater,
          breakpoint: StyleSizeType.XSmall,
          imageSize: 350,
        },
      ];
    },
  },
};
